import React from 'react';

import Navbar from '../components/Navbar';
import ProtectionOfMinorsContent from '../components/ProtectionOfMinorsContent';
import Footer from '../components/Footer';

const ProtectionOfMinors = () => {
    return (
        <>
            <Navbar />
            <ProtectionOfMinorsContent />
            <Footer />
        </>
    );
};

export default ProtectionOfMinors;
